var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 38H18H12V20L24 11L26.4132 12.8099L29.5537 10.1653L24 6L8 18V42H22H26H40V38H36H30H25Z",
    fill: "#53B374"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30.5C35.25 30.5 36.3127 30.0627 37.188 29.188C38.0627 28.3127 38.5 27.25 38.5 26C38.5 24.75 38.0627 23.6873 37.188 22.812C36.3127 21.9373 35.25 21.5 34 21.5C32.75 21.5 31.6873 21.9373 30.812 22.812C29.9373 23.6873 29.5 24.75 29.5 26C29.5 27.25 29.9373 28.3127 30.812 29.188C31.6873 30.0627 32.75 30.5 34 30.5ZM24 34V18H29.15L31 16H37L38.85 18H44V34H24Z",
    fill: "#53B374"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePhoto);
export default __webpack_public_path__ + "static/media/home_photo.7c8716a5d82e7f8b9e658858870fddb2.svg";
export { ForwardRef as ReactComponent };